/* Noire Atelier — search.js (predictive search) */
(function () {
  'use strict';
  const RECENT_KEY = 'noire:searches';

  function readRecent() {
    try { return JSON.parse(window.localStorage.getItem(RECENT_KEY)) || []; } catch (e) { return []; }
  }
  function saveRecent(q) {
    try {
      let list = readRecent().filter((x) => x.toLowerCase() !== q.toLowerCase());
      list.unshift(q);
      window.localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 6)));
    } catch (e) { /* ignore */ }
  }

  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('[data-predictive-results]');
      this.status = this.querySelector('[data-predictive-status]');
      this.form = this.querySelector('form');
      if (!this.input || !this.results) return;
      this.popular = [];
      try { this.popular = JSON.parse(this.dataset.popular || '[]'); } catch (e) { this.popular = []; }
      this.popular = this.popular.map((s) => String(s).trim()).filter(Boolean);
      this.input.setAttribute('role', 'combobox');
      this.input.setAttribute('aria-expanded', 'false');
      this.input.setAttribute('aria-autocomplete', 'list');
      this.input.setAttribute('autocomplete', 'off');
      this.input.addEventListener('input', window.NoireUtils.debounce(() => this.onInput(), 300));
      this.input.addEventListener('focus', () => { if (!this.input.value.trim()) this.renderIdle(); });
      this.addEventListener('keydown', (e) => this.onKeydown(e));
      if (this.form) {
        this.form.addEventListener('submit', () => {
          const q = this.input.value.trim();
          if (q) saveRecent(q);
        });
      }
      this.renderIdle();
    }
    onInput() {
      const q = this.input.value.trim();
      if (this.controller) this.controller.abort();
      if (!q) { this.renderIdle(); return; }
      this.controller = new AbortController();
      const params = new URLSearchParams({
        q,
        'resources[type]': 'product,collection,page,article',
        'resources[limit]': '4',
        'resources[limit_scope]': 'each',
        section_id: 'predictive-search'
      });
      fetch(window.routes.predictive_search_url + '?' + params.toString(), { signal: this.controller.signal })
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const inner = doc.querySelector('[data-predictive-inner]');
          this.results.innerHTML = inner ? inner.innerHTML : '';
          this.input.setAttribute('aria-expanded', 'true');
          if (this.status) {
            const count = this.results.querySelectorAll('a').length;
            this.status.textContent = (this.dataset.msgResults || '[count]').replace('[count]', count);
          }
        })
        .catch(() => {});
    }
    renderIdle() {
      const recent = readRecent();
      let html = '';
      const esc = (s) => s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
      if (recent.length) {
        html += '<p class="predictive__group-title">' + esc(this.dataset.labelRecent || '') + '</p><div class="predictive__tags">';
        recent.forEach((q) => {
          html += '<a href="' + window.routes.search_url + '?q=' + encodeURIComponent(q) + '">' + esc(q) + '</a>';
        });
        html += '</div>';
      }
      if (this.popular.length) {
        html += '<p class="predictive__group-title">' + esc(this.dataset.labelPopular || '') + '</p><div class="predictive__tags">';
        this.popular.forEach((q) => {
          html += '<a href="' + window.routes.search_url + '?q=' + encodeURIComponent(q) + '">' + esc(q) + '</a>';
        });
        html += '</div>';
      }
      this.results.innerHTML = html;
      this.input.setAttribute('aria-expanded', html ? 'true' : 'false');
    }
    onKeydown(e) {
      const links = Array.from(this.results.querySelectorAll('a'));
      if (!links.length) return;
      const current = links.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        (links[current + 1] || links[0]).focus();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        if (current === 0 || current === -1) this.input.focus();
        else links[current - 1].focus();
      } else if (e.key === 'Escape') {
        this.results.innerHTML = '';
        this.input.setAttribute('aria-expanded', 'false');
        this.input.focus();
      }
    }
  }
  if (!customElements.get('predictive-search')) customElements.define('predictive-search', PredictiveSearch);
})();
